import { Box, Image, VStack, Text } from '@chakra-ui/react';
import { Link } from "react-router-dom";
import FadeInElement from './utils/FadeInElement/FadeInElement';
import projectsVideo from './data/assets/Main/projects-video.png' 
import projectsPhoto from './data/assets/Main/projects-photo.png'
import projectsDesign from './data/assets/Main/projects-design.png' 

const ProyectsGallery = ( { text } ) => {
  return (
    <VStack
      display='flex'
      id='projects'
      alignItems={'center'}
      py='2%'
      w={['100%','100%','85vw','60vw']}
      minH={['100%','100%','100vh','100vh', '100vh']}
      overflow={['hidden','visible']}
    >

        <Text display={['block', 'none']} fontSize='4xl' pt='20%' pb={'10%'} fontWeight='600'> {text.sectionTitle} </Text>
        
        <VStack display={['none', 'none', 'flex', 'flex', 'flex']} align='center' gap={[0, 0, '20', '60px', '60px']}>
          <FadeInElement side='right'>
            <ProjectHorizontalCard
              title={text.Foto.tit}
              subtitle={text.Foto.sub}
              sectionLink={'/photography'}
              imgSource={projectsPhoto}
            />
          </FadeInElement>

          <FadeInElement side='left'>
            <ProjectHorizontalCard
              title={text.Video.tit}
              subtitle={text.Video.sub}
              sectionLink={'/video'}
              imgSource={projectsVideo}
            />
          </FadeInElement>        

          <FadeInElement side='right'>
            <ProjectHorizontalCard
              title={text.Disenio.tit}
              subtitle={text.Disenio.sub}
              sectionLink={'/design'}
              imgSource={projectsDesign}
            />
          </FadeInElement>
        </VStack>
        <VStack display={['flex', 'flex', 'none', 'none', 'none']} align='center' gap={4} px='2%'>
          <FadeInElement side='right'>
            <ProjectVerticalCard
              title={text.Foto.tit}
              subtitle={text.Foto.sub}
              sectionLink={'/photography'}
              imgSource={projectsPhoto}
            />
          </FadeInElement>

          <FadeInElement side='left'>
            <ProjectVerticalCard
              title={text.Video.tit}
              subtitle={text.Video.sub}
              sectionLink={'/video'}
              imgSource={projectsVideo}
            />
          </FadeInElement>        

          <FadeInElement side='right'>
            <ProjectVerticalCard
              title={text.Disenio.tit}
              subtitle={text.Disenio.sub}
              sectionLink={'/design'}
              imgSource={projectsDesign}
            />
          </FadeInElement>

        </VStack>
    </VStack>
  )
}

function ProjectHorizontalCard({ title, subtitle, sectionLink, imgSource }) {
  return(
    <Link width={'100%'} h='100%' to={sectionLink}>
      <Box
        w={'100%'}
        h={['100%']}
        position='relative'
        _hover={ { transform: 'scale(1.01);' } }
        transitionDuration='0.7s'
        >
          <Image
            width={'100%'}
            boxSize='100%'
            objectFit='cover'
            src={imgSource}
            alt={title}
            transitionDuration={'0.7s'}
            opacity='0.9' _hover={ { opacity: '0.7'} } 
          /> 
          {/* Desktop */}
          <Box
            display={['none', 'block']}
            w='100%' h={['20%','20%','25%','20%']} position='absolute' bottom='0' zIndex='5' paddingBottom={"6px"}
            bgGradient='linear-gradient(180deg, rgba(29, 29, 29, 0) 0%, rgba(29, 29, 29, 0) 0.01%, #1C1C1C 100%)' 
          >
            <Text fontSize='3xl' fontStyle={'bold'} color='white' px='3%' pt='0.5%'> {title} </Text>
            {/* <Text fontSize='xs' color='white' px='3%'> {subtitle} </Text>  */}
          </Box>
          {/* Mobile */}
          <VStack display={['block', 'none']} position='absolute' top='30%' boxSize='100%' zIndex='5' textAlign='center'>
            <Text position='relative' color='Black' fontSize='lg' mt='20%'> {title} </Text>
          </VStack>
        
      </Box>
    </Link>
  );
}


function ProjectVerticalCard({ title, subtitle, sectionLink, imgSource }) {
  
  return (
    <VStack position='relative' key={title} spacing={4} align="center" transitionDuration={'0.5s'} _hover={{ transform: 'scale(1.005);' }}>
      <Link w='100%' h='100%' to={sectionLink}>
        <Box w="100%" aspectRatio={4 / 3} overflow="hidden" borderRadius="md">
          <Image
            src={imgSource}
            alt={title}
            objectFit="cover"
            w="100%"
            h="100%"
          />
        </Box>
        <Box
          w='100%'
          h={['20%','20%','25%','20%']}
          paddingBottom={'10%'}
          position='absolute' bottom='0' zIndex='5'
          bgGradient='linear-gradient(180deg, rgba(29, 29, 29, 0) 0%, rgba(29, 29, 29, 0) 0.01%, #1C1C1C 100%)' 
        >
          <Text fontSize='3xl' color='white' fontStyle={'bold'} px='3%' pt='0.5%'> {title} </Text>
          <Text fontSize='xs' color='white' px='3%' overflow={"break-word"}> {subtitle} </Text> 
        </Box>
      </Link>
    </VStack>
  );
}



export default ProyectsGallery;